module.exports = __webpack_public_path__ + "static/media/icon_story_talk_channelbc256d3ea8c3ce11e1de2ae5e55e3016.webp";